class JascanoHero extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-panel]').forEach((panel) => {
      const video = panel.querySelector('[data-panel_video]');
      if (!video) return;

      const isMobile = matchMedia('(hover: none)').matches;

      const play = () => {
        panel.classList.add('is-playing');
        try { video.play(); } catch {}
      };
      const pause = () => {
        panel.classList.remove('is-playing');
        try { video.pause(); video.currentTime = 0; } catch {}
      };

      panel.addEventListener('mouseenter', play);
      panel.addEventListener('mouseleave', pause);
      panel.addEventListener('focusin', play);
      panel.addEventListener('focusout', pause);

      // Mobile autoplay: keep image as thumbnail until video starts
      if (isMobile) {
        panel.setAttribute('data-mobile-autoplay', 'true');
        try {
          video.muted = true; // ensure autoplay works on mobile
          video.setAttribute('muted', '');
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.autoplay = true;
          video.setAttribute('autoplay', '');
          video.preload = 'auto';
        } catch {}

        // Show video only when it is ready/playing; image stays visible until then
        const revealOnReady = () => panel.classList.add('is-playing');
        video.addEventListener('playing', revealOnReady, { once: true });
        video.addEventListener('canplay', revealOnReady, { once: true });
        // Attempt to start playback
        try { video.play().catch(() => {}); } catch {}
      }

      // Mobile: previously tap-to-toggle; keep it for non-autoplay cases only
      panel.addEventListener('click', (e) => {
        if (matchMedia('(hover: none)').matches && !panel.hasAttribute('data-mobile-autoplay')) {
          if (video.paused) {
            e.preventDefault();
            play();
            setTimeout(() => panel.setAttribute('data-armed', 'true'), 0);
          } else if (!panel.hasAttribute('data-armed')) {
            e.preventDefault();
            pause();
          }
        }
      });
    });

    // Sync navbar logo animation with hero center logo
    const header = document.querySelector('#header-component');
    const headerLogo = header?.querySelector('.header-logo');
    const heroCenterLogo = this.querySelector('.jascano-hero__center-logo');
    if (header && headerLogo && heroCenterLogo) {
      const setDx = () => {
        const rect = headerLogo.getBoundingClientRect();
        const dx = Math.round(window.innerWidth / 2 - (rect.left + rect.width / 2));
        headerLogo.style.setProperty('--nav-slide-dx', `${dx}px`);
      };
      setDx();
      window.addEventListener('resize', () => { setDx(); updateState(); }, { passive: true });

      header.classList.add('navlogo-prep');

      const updateState = () => {
        const headerRect = header.getBoundingClientRect();
        const heroRect = heroCenterLogo.getBoundingClientRect();
        const threshold = 2; // px overlap allowance
        if (heroRect.top <= headerRect.bottom + threshold) {
          header.classList.add('navlogo-animate');
          heroCenterLogo.classList.add('is-hidden');
        } else {
          header.classList.remove('navlogo-animate');
          heroCenterLogo.classList.remove('is-hidden');
        }
      };

      const onScroll = () => requestAnimationFrame(updateState);
      document.addEventListener('scroll', onScroll, { passive: true });
      updateState();
    }
  }
}

if (!customElements.get('jascano-hero')) {
  customElements.define('jascano-hero', JascanoHero);
}
